var map = {
	"./add.svg": "76a4",
	"./add_product.svg": "0b81",
	"./administracja.svg": "baac",
	"./administracja_inactive.svg": "34ce",
	"./aggregate_transport_green.svg": "c321",
	"./aggregate_transport_small.svg": "bcbc",
	"./alert_delivered.svg": "8d34",
	"./alert_opened.svg": "aecf",
	"./alert_sent.svg": "b8a2",
	"./arrow-down.svg": "c874",
	"./assign_a_driver_small.svg": "016d",
	"./assign_card.svg": "c72c",
	"./attachment.svg": "3e0e",
	"./base_green.svg": "9fbc",
	"./base_map.svg": "3af3",
	"./base_one.svg": "7bd6",
	"./block-mark.svg": "807c",
	"./blockClient.svg": "db18",
	"./blockSchedule.svg": "bde9",
	"./checkbox_active.svg": "85bc",
	"./checkbox_active_small.svg": "bf9c",
	"./checkbox_inactive.svg": "565e",
	"./checkbox_inactive_small.svg": "fcec",
	"./checkmark.svg": "1ec3",
	"./client.svg": "c58b",
	"./cofnij_wyslanie_kursu.svg": "7ea4",
	"./container.svg": "e6c3",
	"./date.svg": "70f5",
	"./date_small.svg": "11d2",
	"./dolar.svg": "5728",
	"./dostosuj_tabele.svg": "a2e5",
	"./drag.svg": "88c6",
	"./driver-settlements/account-multiple.svg": "4456",
	"./driver-settlements/calendar-today.svg": "de0d",
	"./driver-settlements/camera-timer.svg": "26b0",
	"./driver-settlements/car-back.svg": "b45b",
	"./driver-settlements/car-speed-limiter.svg": "fd58",
	"./driver-settlements/clock.svg": "dbc7",
	"./driver-settlements/dump-truck.svg": "5455",
	"./driver-settlements/highway.svg": "bf7f",
	"./driver-settlements/loop.svg": "acb4",
	"./driver-settlements/map-marker-distance.svg": "11c8",
	"./driver-settlements/rotate-360.svg": "a5c0",
	"./driver-settlements/slash-forward.svg": "eda0",
	"./driver-settlements/tab-plus.svg": "fe2d",
	"./driver-settlements/timelapse.svg": "0326",
	"./dropdown.svg": "6d05",
	"./dropdown_inactive.svg": "302f",
	"./dropdown_not_selected.svg": "9864",
	"./dropdown_selected.svg": "91a6",
	"./edytuj.svg": "8662",
	"./exchange_green.svg": "aa39",
	"./expand.svg": "83364",
	"./faktury.svg": "9b1c",
	"./faktury_inactive.svg": "ee2d",
	"./folder-upload.svg": "3d37",
	"./hourse_range.svg": "d999",
	"./icon_exchange.svg": "a1a7",
	"./icon_substitution.svg": "ae34",
	"./icon_take_away.svg": "d0d3",
	"./icon_transport.svg": "651e",
	"./incydenty.svg": "2aaf",
	"./incydenty_inactive.svg": "56b2",
	"./invoices_inactive.svg": "08ce",
	"./karty_bdo.svg": "4e5a",
	"./karty_bdo_inactive.svg": "cff0",
	"./klienci.svg": "3639",
	"./klienci_inactive.svg": "0ea8",
	"./klient.svg": "af6b",
	"./komunikaty.svg": "2316",
	"./komunikaty_inactive.svg": "71b5",
	"./kontenery.svg": "1d62",
	"./kontenery_inactive.svg": "c7f5",
	"./kursy.svg": "6b20",
	"./kursy_inactive.svg": "1fb5",
	"./location.svg": "d2eb",
	"./logout.svg": "69e3",
	"./loop_green.svg": "367b",
	"./map-icons/icon_exchange.svg": "139c",
	"./map-icons/icon_substitution.svg": "d6f2",
	"./map-icons/icon_take_away.svg": "57a1",
	"./map-icons/icon_transport.svg": "63a7",
	"./map-pins/base.svg": "b33d",
	"./map-pins/driver_available.svg": "10ff",
	"./map-pins/driver_unavailable.svg": "5bc1",
	"./map-pins/pin_exchange_blue.svg": "285b",
	"./map-pins/pin_exchange_green.svg": "b07f",
	"./map-pins/pin_exchange_orange.svg": "7756",
	"./map-pins/pin_exchange_purple.svg": "7e3f",
	"./map-pins/pin_exchange_red.svg": "78e1",
	"./map-pins/pin_substitution_blue.svg": "add8",
	"./map-pins/pin_substitution_green.svg": "1cf4",
	"./map-pins/pin_substitution_orange.svg": "0332",
	"./map-pins/pin_substitution_purple.svg": "b579",
	"./map-pins/pin_substitution_red.svg": "9439",
	"./map-pins/pin_take_away_blue.svg": "709f",
	"./map-pins/pin_take_away_green.svg": "e147",
	"./map-pins/pin_take_away_orange.svg": "8efd",
	"./map-pins/pin_take_away_purple.svg": "b9f9",
	"./map-pins/pin_take_away_red.svg": "1092",
	"./map-pins/pin_transport_blue.svg": "4588",
	"./map-pins/pin_transport_green.svg": "ae59",
	"./map-pins/pin_transport_orange.svg": "216a",
	"./map-pins/pin_transport_purple.svg": "1277",
	"./map-pins/pin_transport_red.svg": "32e2",
	"./map-pins/simple/pin_exchange_blue.svg": "100b",
	"./map-pins/simple/pin_exchange_green.svg": "806e",
	"./map-pins/simple/pin_exchange_orange.svg": "ffda",
	"./map-pins/simple/pin_exchange_purple.svg": "235b",
	"./map-pins/simple/pin_exchange_red.svg": "8ed2",
	"./map-pins/simple/pin_substitution_blue.svg": "3097",
	"./map-pins/simple/pin_substitution_green.svg": "3f09",
	"./map-pins/simple/pin_substitution_orange.svg": "e0ea",
	"./map-pins/simple/pin_substitution_purple.svg": "9c8d",
	"./map-pins/simple/pin_substitution_red.svg": "78ea",
	"./map-pins/simple/pin_take_away_blue.svg": "dd7e",
	"./map-pins/simple/pin_take_away_green.svg": "a46d",
	"./map-pins/simple/pin_take_away_orange.svg": "511c",
	"./map-pins/simple/pin_take_away_purple.svg": "be8c",
	"./map-pins/simple/pin_take_away_red.svg": "48c3",
	"./map-pins/simple/pin_transport_blue.svg": "5870",
	"./map-pins/simple/pin_transport_green.svg": "1e94",
	"./map-pins/simple/pin_transport_orange.svg": "df2e",
	"./map-pins/simple/pin_transport_purple.svg": "d614",
	"./map-pins/simple/pin_transport_red.svg": "b538",
	"./map_containers.svg": "7bcb",
	"./map_containers_active.svg": "3af8",
	"./map_courses.svg": "600c",
	"./map_courses_active.svg": "327f",
	"./mapa.svg": "5d35",
	"./mapa_inactive.svg": "79cd",
	"./payment_status.svg": "a942",
	"./phone.svg": "c3bb",
	"./pobierz.svg": "b936",
	"./podstawienie.svg": "3060",
	"./przypisz_kierowce.svg": "ce93",
	"./radio_button_active.svg": "d9ef",
	"./radio_button_inactive.svg": "df6b",
	"./raporty.svg": "7a95",
	"./raporty_inactive.svg": "f8afc",
	"./rozliczenia.svg": "2aea",
	"./rozliczenia_inactive.svg": "fe8b",
	"./search-glass.svg": "519f",
	"./search.svg": "d103",
	"./substitution_green.svg": "23bd",
	"./substitution_small.svg": "b53b",
	"./synchronizacja.svg": "5df7",
	"./take_away_green.svg": "bbf7",
	"./take_away_map.svg": "f33a",
	"./take_away_small.svg": "4a41",
	"./time_standing.svg": "0cd6",
	"./unblockClient.svg": "5ffc",
	"./unblockSchedule.svg": "cb1e",
	"./user.svg": "6aed",
	"./usun.svg": "f8ff",
	"./wygeneruj_fakture.svg": "a53a",
	"./wyslij_kurs.svg": "3363",
	"./zablokuj_zlecenie.svg": "c3f3",
	"./zabranie.svg": "b57d",
	"./zadania.svg": "3558",
	"./zadania_inactive.svg": "540c",
	"./zadanie_wykonane.svg": "1394",
	"./zamknij.svg": "3688",
	"./zamknij_small.svg": "487a",
	"./zamowienia.svg": "df0e",
	"./zamowienia_inactive.svg": "f630",
	"./zlecenia.svg": "dc62",
	"./zlecenia_inactive.svg": "fee3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";